import { connect } from "react-redux"

import EventListWidget from "QuorumGrassroots/widgets/EventList/components/index"

import { eventListSelectors } from "QuorumGrassroots/widgets/EventList/selectors"

import { withNamespaces } from "react-i18next"

export default withNamespaces()(connect(eventListSelectors, null)(EventListWidget))
